import { createSelector } from '@reduxjs/toolkit';
import { selectMarketTrendsStatus } from './selectMarketTrendsStatus';
import { selectRoomsCount } from './selectRoomsCount';
import { selectPeriod } from './selectPeriod';
import { selectMarketTrendsData } from './selectMarketTrendsData';
import { selectFiltersAvailability } from './selectFiltersAvailability';
import { EMarketTrendsStatus } from 'shared/types/marketTrends';

export const selectMarketTrends = createSelector(
  selectFiltersAvailability,
  selectMarketTrendsData,
  selectMarketTrendsStatus,
  selectRoomsCount,
  selectPeriod,
  (filtersAvailability, marketTrends, status, roomsCount, period) =>
    marketTrends
      ? {
          ...marketTrends,
          filtersAvailability,
          isLoading: status === EMarketTrendsStatus.Loading,
          roomsCount,
          period,
        }
      : /* istanbul ignore next */ null,
);
